<div class="row d-flex align-items-center">
	<div class="col-auto">
		<!-- bread-crumbs start -->
		<nav aria-label="breadcrumb" class="me-2 small">
			<ol class="breadcrumb bg-white px-0 mb-0">
				<!-- parent-module sec start -->
				<li class="breadcrumb-item">
					<div class="crumbs">
						<a class="mb-0 align-items-center text-decoration-none text-dark">
							<span *ngIf="parentDetails?.name" class="me-1 d-none d-md-inline">{{parentDetails?.name}}
								-</span>
							<span>{{moduleDetails?.name}}</span>
						</a>
					</div>
				</li>
				<!-- parent-module sec end  -->
				<!-- page sec start  -->
				<li class="breadcrumb-item dropdown">
					<a class="mb-0 align-items-center dropdown-toggle crumbs text-truncate pointer text-decoration-none text-primary bc-hover-color"
						data-bs-toggle="dropdown" data-bs-offset="0,15">
						<span class="me-2">{{pageDetails?.name}}</span>
						<i class="mdi mdi-chevron-down"></i>
					</a>
					<div class="dropdown-menu border-0 rounded shadow">
						<ng-container *ngFor="let data of moduleDetails?.children">
							<a *ngIf="data?.name" class="dropdown-item small pointer"
								[ngClass]="{'active':data?.path == currentUrl?.split('/')?.pop()?.split('?')?.shift()}"
								[routerLink]="[moduleDetails?.path,data?.path]">{{data?.name}}</a>
						</ng-container>
					</div>
				</li>
				<!-- page sec start  -->
			</ol>
		</nav>
		<!-- bread-crumbs end -->
	</div>
	<div class="col ps-0">
		<div class="d-flex">
			<ng-content></ng-content>
		</div>
	</div>
</div>
<div class="d-flex align-items-center">


</div>